import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

export const trackBackToListingClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'Enquiry',
        eventAction: 'Click',
        eventLabel: 'Back to listing'
    });
};
